import React, { FC, Fragment } from 'react';
import clsx from 'classnames';
import { DetailProps } from '../views.types';
import { getDetail } from '../utils';

import styles from './styles.module.scss';

export const FileDetails: FC<DetailProps> = props => {
  const data = getDetail(props);
  return (
    <div className="flex flex-col w-full h-full min-h-0">
      <div className="p-4 bg-gray-50 flex justify-between items-center uppercase">Detalles</div>
      <div className={styles.table}>
        {data.map((group: any) => (
          <Fragment key={group.name}>
            <p className="font-semibold pt-4 pb-2">{group.name}</p>
            {group.items.map((item: any, index: number) => (
              <div
                className={clsx(styles.row, { 'border-t': index === 0, [styles.emptySection]: !item.name })}
                key={item.name + index}>
                <span className="border-r py-2">{item.name}</span>
                <span className="col-span-2 uppercase break-words">{item.value}</span>
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    </div>
  );
};
